import { isAbortError } from 'utils/abortRequest/isAbortError';

export interface AbortableFinished<T> {
  aborted: false;
  data: T;
}

export interface AbortableAborted {
  aborted: true;
  data?: never;
}

export type AbortableResult<T> = AbortableFinished<T> | AbortableAborted;

export const abortable =
  <TArgs extends unknown[], TReturn>(
    fn: (...args: TArgs) => Promise<TReturn>,
  ): ((...args: TArgs) => Promise<AbortableResult<TReturn>>) =>
  async (...args) => {
    try {
      return {
        aborted: false,
        data: await fn(...args),
      };
    } catch (e) {
      if (isAbortError(e)) {
        return { aborted: true };
      }
      throw e;
    }
  };
